import { FunctionComponent } from 'react';
import { Div, Headline, BodyText, Button, Image } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import { createAuthenticationUrl } from '../../../utils';
import teliaCroppedLogo from '../../../assets/images/shiny-pebble-cropped2x.svg';
import classes from './LoggedOut.module.css';

const LoggedOut: FunctionComponent = () => {
  const { t } = useTranslation('authentication');

  const handleLoginClick = (): void => {
    globalThis.location.href = createAuthenticationUrl();
  };

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Headline size="md" block>
        {t('LogoutComponent.mainText')}
      </Headline>
      <BodyText margin={{ vertical: 'xlg' }} padding={{ vertical: 'md' }} color="gray800">
        {t('LogoutComponent.instruction')}
      </BodyText>
      <Button variant="secondary" size="lg" onClick={handleLoginClick}>
        {t('LogoutComponent.loginButton')}
      </Button>
      <Div className={classes['telia-logo']}>
        <Image src={teliaCroppedLogo} alt="telia image" />
      </Div>
    </Div>
  );
};

export default LoggedOut;
